import React from 'react';
import { object, func, array } from 'prop-types';
import style from './style';
import MultipleChoice from './MultipleChoice';
import FillInTheBlank from './FillInTheBlank';

function AnswerForm({options,answers,correctAnswers,onAnswer,...props}) {
	const answersUnique = Array.from(new Set(correctAnswers || []));
	const components = answersUnique.map((correctAnswer,idx)=>{
		const targetOptions = options[correctAnswer];
		const answer = correctAnswer in answers ? answers[correctAnswer] : null;
		if(targetOptions){
			const {candidates=[]} = targetOptions;  
			if(candidates.length > 1){
				return (
					<MultipleChoice 
						correctAnswer={correctAnswer}
						answer={answer}
						targetOptions={candidates}
						onAnswer={onAnswer}
						index={idx}
					/>
				);
			}
		}
		return (
			<FillInTheBlank 
				key={correctAnswer}
				correctAnswer={correctAnswer}
				answer={answer}
				onAnswer={onAnswer}
				index={idx}
			/>);
	});
	return (
		<style.ContentLayout {...props}>
			{components}
		</style.ContentLayout>
	);
}

AnswerForm.propTypes = {
	options: object,
	answers: object,
	correctAnswers:array,
	onAnswer: func
};

export default AnswerForm;

